__turbopack_context__.v({
  "badge": "_4ig7Ma_badge",
  "bellButton": "_4ig7Ma_bellButton",
});
